import { render, staticRenderFns } from "./VaIconColor.vue?vue&type=template&id=94fb98ce"
import script from "./VaIconColor.vue?vue&type=script&lang=js"
export * from "./VaIconColor.vue?vue&type=script&lang=js"
import style0 from "./VaIconColor.vue?vue&type=style&index=0&id=94fb98ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports